export default __webpack_public_path__ + "fonts/bc00e3724abd8e921b78b8558e54a8da.svg";